<div
  id="support"
  #supportElement
  class="relative w-full h-full flex flex-col"
  (dragover)="onDragOver($event)"
  (dragleave)="onDragLeave($event)"
  (drop)="onGlobalDrop($event)"
  cdkTrapFocus
  tabindex="0"
  [cdkTrapFocusAutoCapture]="true">
  <div
    *ngIf="remainingMessagesCount > 0"
    class="all-messages-btn yellow-100 w-full flex flex-col justify-center items-center">
    <button mat-button class="w-full" (click)="loadAllMessages()" i18n
      >Показать предыдущие {{ remainingMessagesCount }}</button
    >
  </div>

  <!-- CENTER -->
  <div class="flex-1 overflow-auto" #messageContainer>
    <div class="mt-4 mb-10">
      <mat-spinner *ngIf="loadingMessages$ | async" class="mx-auto" [diameter]="40"></mat-spinner>
    </div>

    <div class="px-4 sm:px-6 lg:px-8">
      <csl-support-chat-message
        [questionId]="questionId"
        [myId]="myId"
        *ngIf="allMessages$ | async as messages"
        class="flex flex-col flex-1 overflow-auto"
        [messages]="messages"></csl-support-chat-message>
    </div>
  </div>

  <!-- Message input -->
  <div class="quill-editor-container w-full p-6 lg:p-8">
    <quill-editor
      #quillEditor
      class="w-full block"
      [(ngModel)]="messageText"
      [bounds]="'self'"
      [modules]="quillModules"
      [styles]="editorStyle"
      i18n-placeholder
      placeholder="Введите сообщение..."></quill-editor>
    <div class="p-2 border hidden sm:block rounded-b-md border-gray-300 text-sm text-gray-500" i18n
      ><kbd>Ctrl</kbd> + <kbd>V</kbd> для вставки файла из буфера обмена</div
    >
    <div class="flex flex-row justify-between gap-8 items-center mt-4">
      <div
        class="mt-5 flex flex-col justify-between p-4 gap-4 max-h-20 sm:max-h-full w-full overflow-y-auto sm:overflow-visible">
        <div class="w-full flex flex-col sm:flex-row sm:space-x-2">
          <mat-chip-list>
            <mat-chip
              class="whitespace-nowrap"
              *ngFor="let attachment of attachments; let i = index"
              removable
              (removed)="removeFile(i)">
              {{ attachment.fileName }} | ({{ attachment.fileSize | fileSize }})
              <mat-icon matChipRemove>cancel</mat-icon>
            </mat-chip>
          </mat-chip-list>
        </div>
      </div>

      <div class="mt-4 flex text-right">
        <ng-container *ngFor="let button of actionButtons">
          <button mat-raised-button color="accent" class="mr-2" (click)="button.action()">{{ button.title }}</button>
        </ng-container>
        <button i18n mat-raised-button color="accent" (click)="sendMessage()" *ngIf="!question || !question.closed"
          >Отправить</button
        >
      </div>
    </div>
  </div>

  <div
    *ngIf="!isMobile && isDragging$ | async"
    class="drop-zone absolute border-dashed bg-opacity-90 bg-blue-100 border-2 border-blue-500 flex items-center justify-center"
    (drop)="onDrop($event)">
    <div class="text-center text-blue-500">
      <mat-icon class="mx-auto mb-4 icon-size-24"> cloud_upload </mat-icon>
      <p i18n class="text-xl sm:text-2xl lg:text-3xl">Перетаскивайте файлы сюда чтобы отправить их</p>
    </div>
  </div>
</div>
